module.exports = __webpack_public_path__ + "img/2.f947ee63.png";